"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStorageKeys = void 0;
var SessionStorageKeys;
(function (SessionStorageKeys) {
    SessionStorageKeys["RetirementFlowLastStep"] = "RetirementFlowLastStep";
    SessionStorageKeys["RetirementFlowModel"] = "RetirementFlowModel";
    SessionStorageKeys["DebtFlowModel"] = "DebtFlowModel";
    SessionStorageKeys["FinancialProfileFlowModel"] = "FinancialProfileFlowModel";
    SessionStorageKeys["WelcomeFlowModel"] = "WelcomeFlowModel";
    SessionStorageKeys["WelcomeFlowLastStep"] = "WelcomeFlowLastStep";
    SessionStorageKeys["RiskAttitudeData"] = "RiskAttitudeData";
    SessionStorageKeys["RiskAttitudeFlowLastStep"] = "RiskAttitudeFlowLastStep";
    SessionStorageKeys["MoneyToWorkFlowLastStep"] = "MoneyToWorkFlowLastStep";
    SessionStorageKeys["MoneyToWorkFileNetPreSaved"] = "MoneyToWorkFileNetPreSaved";
    SessionStorageKeys["LoggedUserId"] = "LoggedUserId";
    SessionStorageKeys["MoneyToWorkAcceptedStep"] = "MoneyToWorkAcceptedStep";
    SessionStorageKeys["AddCashFlowModel"] = "AddCashFlowModel";
    SessionStorageKeys["AddCashFlowLastStep"] = "AddCashFlowLastStep";
    SessionStorageKeys["GetCashFlowModel"] = "GetCashFlowModel";
    SessionStorageKeys["GetCashFlowLastStep"] = "GetCashFlowLastStep";
    SessionStorageKeys["DebtFlowLastStep"] = "DebtFlowLastStep";
    SessionStorageKeys["FinancialProfileFlowLastStep"] = "FinancialProfileFlowLastStep";
    SessionStorageKeys["VmapExitModalShown"] = "VmapExitModalShown";
    SessionStorageKeys["ProspectFlowLastStep"] = "ProspectFlowLastStep";
    SessionStorageKeys["ExpenseCategories"] = "ExpenseCategories";
    SessionStorageKeys["RiskQuizModalOnDashboardShown"] = "RiskQuizModalOnDashboardShown";
    SessionStorageKeys["IndexStartTime"] = "IndexStartTime";
    SessionStorageKeys["VmapIsPrepersonalization"] = "VmapIsPrepersonalization";
    SessionStorageKeys["PutYourMoneyToWork"] = "PutYourMoneyToWork";
    SessionStorageKeys["ReadyToEnrollAccounts"] = "ReadyToEnrollAccounts";
    SessionStorageKeys["MultiSessionAccountsSave"] = "MultiSessionAccountsSave";
    SessionStorageKeys["ReturnFlowLastStep"] = "ReturnFlowLastStep";
    SessionStorageKeys["VmapWelcomeCheckbox"] = "VmapWelcomeCheckbox";
    SessionStorageKeys["ConfirmRetirementFlow"] = "ConfirmRetirementFlow";
    SessionStorageKeys["CGFlowActiveGoal"] = "CGFlowActiveGoal";
    SessionStorageKeys["CGFlowGoals"] = "CGFlowGoals";
    SessionStorageKeys["FirstMonthExperienceFlow"] = "FirstMonthExperienceFlow";
    SessionStorageKeys["FirstMonthExperienceSnoozedCards"] = "FirstMonthExperienceSnoozedCards";
    SessionStorageKeys["AddingAccountToPlan"] = "AddingAccountToPlan";
    SessionStorageKeys["ProspectIncomeSavingsAmount"] = "ProspectIncomeSavingsAmount";
    SessionStorageKeys["AppointmentType"] = "AppointmentType";
    SessionStorageKeys["AppointmentData"] = "appointmentData";
    SessionStorageKeys["NudgeClosed"] = "NudgeClosed";
    SessionStorageKeys["PortfolioBuilderKey"] = "PortfolioBuilderKey";
    SessionStorageKeys["ContributionsFlowLastStep"] = "ContributionsFlowLastStep";
    SessionStorageKeys["Pc7StorageKey"] = "Pc7Storage";
    SessionStorageKeys["ScreenTakeoverVisited"] = "ScreenTakeoverVisited";
    SessionStorageKeys["PageVisitIncremented"] = "PageVisitIncremented";
    SessionStorageKeys["NavigatedAwayFromDashboard"] = "NavigatedAwayFromDashboard";
    SessionStorageKeys["PbjPortfolioTypeDraftIds"] = "PbjPortfolioTypeDraftIds";
    SessionStorageKeys["BcxSessionStorageExtended"] = "BcxSessionStorageExtended";
})(SessionStorageKeys = exports.SessionStorageKeys || (exports.SessionStorageKeys = {}));
